export function normalizeGta(gta: string): string {
  return gta.replace(/\/$/, '');
}

export function shouldLoadTranslations(
  gta: string,
  language: string,
  translatedGtas: readonly string[]
): boolean {
  return translatedGtas.includes(normalizeGta(gta)) && language !== 'en-US';
}
